import { render, staticRenderFns } from "./AboutAffiantCSV.vue?vue&type=template&id=226c9502"
import script from "./AboutAffiantCSV.vue?vue&type=script&lang=ts"
export * from "./AboutAffiantCSV.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports